
import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-[#fcfaf7] relative overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 w-2 barber-pole opacity-10 hidden lg:block"></div>
      <div className="absolute right-0 top-0 bottom-0 w-2 barber-pole opacity-10 hidden lg:block"></div>
      
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <span className="text-red-800 font-bold uppercase tracking-[0.4em] text-xs">The Wichita Standard</span>
          <h2 className="text-5xl font-serif font-bold mt-4 text-stone-900">A Traditional Cut Above</h2>
        </div>

        <div className="bg-white p-10 md:p-16 shadow-2xl border border-stone-200 rounded-none relative vintage-border">
          <div className="space-y-10 text-center">
            <div className="space-y-4">
              <p className="text-2xl font-serif italic text-stone-900 font-bold">"A place where you can feel at home."</p>
              <div className="h-px w-20 bg-stone-200 mx-auto"></div>
            </div>

            <div className="space-y-6 text-lg text-stone-700 leading-relaxed font-serif max-w-2xl mx-auto">
              <p>
                Since 1992, Norm’s Barber Shop has remained dedicated to the fundamentals of the craft. We believe a haircut is more than a service—it’s a tradition that requires a precise hand and a personable experience.
              </p>
              <p>
                Our shop is designed for those who value quality over speed. Whether you’ve been coming here for decades or it’s your first time in the chair, we take the time to listen and deliver exactly what you’re looking for.
              </p>
            </div>

            <div className="pt-8 border-t border-stone-100">
              <p className="italic text-stone-500 font-serif">
                "Today the art of barbering is returning to those who want good service and a real neighborhood connection."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
